import { useAuth } from "../context/AuthContext";
import { useNav } from "../context/NavContext";

export default function ProfileScreen() {
  const { user, logout } = useAuth();
  const { navigate }     = useNav();

  const handleLogout = () => {
    logout();
    navigate("home");
  };

  const MENU = [
    { icon: "👤", label: "Personal Information" },
    { icon: "🔒", label: "Privacy & Security"   },
    { icon: "📋", label: "My Loan Applications"  },
    { icon: "🧾", label: "Payment History"        },
    { icon: "🎧", label: "Help & Support"         },
    { icon: "⭐", label: "Rate the App"            },
  ];

  return (
    <div style={{ minHeight: "100dvh", background: "#0a1628", position: "relative", overflow: "hidden", paddingBottom: 100 }}>

      {/* Orbs */}
      <div style={{ position: "absolute", top: -60, right: -60, width: 240, height: 240, borderRadius: "50%", background: "#0ea5e9", opacity: 0.1, filter: "blur(70px)", pointerEvents: "none" }} />

      <div style={{ position: "relative", zIndex: 1, padding: "0 20px", maxWidth: 480, margin: "0 auto" }}>

        {/* Header */}
        <div style={{ paddingTop: 28, paddingBottom: 24 }}>
          <h1 style={{ fontSize: 22, fontWeight: 700, color: "#f0f9ff" }}>Profile</h1>
        </div>

        {/* Avatar card */}
        <div style={{ background: "rgba(255,255,255,0.06)", border: "1px solid rgba(255,255,255,0.1)", borderRadius: 20, padding: 24, marginBottom: 20, display: "flex", alignItems: "center", gap: 16, backdropFilter: "blur(12px)" }}>
          <div style={{ width: 64, height: 64, borderRadius: "50%", background: "linear-gradient(135deg, #0ea5e9, #0284c7)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 28, flexShrink: 0 }}>
            👤
          </div>
          <div>
            <p style={{ fontSize: 17, fontWeight: 700, color: "#f0f9ff", marginBottom: 4 }}>User</p>
            <p style={{ fontSize: 13, color: "#7dd3fc" }}>
              {user?.phone ? `+91 ${user.phone}` : "Not logged in"}
            </p>
            <div style={{ display: "inline-block", marginTop: 6, background: "rgba(14,165,233,0.2)", border: "1px solid rgba(14,165,233,0.35)", borderRadius: 20, padding: "2px 10px", fontSize: 10, color: "#7dd3fc" }}>
              ✓ Verified
            </div>
          </div>
        </div>

        {/* Menu items */}
        <div style={{ background: "rgba(255,255,255,0.05)", border: "1px solid rgba(255,255,255,0.09)", borderRadius: 20, overflow: "hidden", backdropFilter: "blur(12px)", marginBottom: 16 }}>
          {MENU.map((item, i) => (
            <div key={item.label}>
              <button style={{
                width: "100%", padding: "16px 20px", background: "none", border: "none",
                display: "flex", alignItems: "center", gap: 14, cursor: "pointer",
                textAlign: "left",
              }}>
                <span style={{ fontSize: 20 }}>{item.icon}</span>
                <span style={{ flex: 1, fontSize: 14, color: "#e0f2fe" }}>{item.label}</span>
                <span style={{ fontSize: 16, color: "rgba(255,255,255,0.25)" }}>›</span>
              </button>
              {i < MENU.length - 1 && <div style={{ height: 1, background: "rgba(255,255,255,0.06)", marginLeft: 56 }} />}
            </div>
          ))}
        </div>

        {/* Logout */}
        <button onClick={handleLogout} style={{
          width: "100%", padding: "16px", border: "1px solid rgba(248,113,113,0.3)", borderRadius: 14,
          background: "rgba(248,113,113,0.08)", color: "#f87171",
          fontSize: 15, fontWeight: 600, cursor: "pointer",
          display: "flex", alignItems: "center", justifyContent: "center", gap: 8,
        }}>
          <span style={{ fontSize: 18 }}>🚪</span>
          Logout
        </button>

        <p style={{ fontSize: 11, color: "rgba(255,255,255,0.2)", textAlign: "center", marginTop: 20 }}>
          LoanShoan v1.0.0 · Built with ♥
        </p>
      </div>
    </div>
  );
}
